<template>
  <div id="experiences">
    <NoResultsFound
        v-if="this.loading === false && this.experiences.length === 0"
    ></NoResultsFound>
    <loader v-if="this.loading" ref="Loader"></loader>
    <Reviews v-if="!this.loading" :reviews="this.experiences"></Reviews>
    <Pagination v-show="!this.loading" :pagination="this.pagination"></Pagination>
  </div>
</template>

<script>
import Reviews from "@/components/Reviews.vue";
import Pagination from "@/components/Pagination.vue";
import Loader from "@/components/Loader.vue";
import {central_api_domain} from "@/constants/endpoints";
import NoResultsFound from "@/components/NoResultsFound.vue";

export default {
  name: "Experiences",
  components: {
    Reviews,
    Pagination,
    Loader,
    NoResultsFound
  },
  data() {
    return {
      name: "Experiences",
      experiences: null,
      pagination: null,
      loading: true,
      filter: null
    };
  },
  methods: {
    setData(object) {
      this.experiences = object.posts;
      this.pagination = object.pagination;
    },
    getName() {
      return this.name;
    },
    loadPosts() {
      this.loading = true;

      let postsFilterString = localStorage.getItem('postsFilter');
      let postsPage = localStorage.getItem('postsPage');
      let postsFilter = JSON.parse(postsFilterString);

      let page = 1;

      if (postsPage !== undefined && postsPage !== '' && postsPage !== null) {
        page = postsPage;
      }

      let url = central_api_domain + "posts/filter";

      if (postsFilter === null) {
        postsFilter = this.getDefaultPostFilter();
      }

      url = url + "?filter=" + JSON.stringify(postsFilter) + '&page=' + page;

      fetch(url)
          .then((res) => res.json())
          .then((result) => {
            this.loading = false;
            let json = JSON.stringify(result);
            let object = JSON.parse(json);
            this.setData(object);
          });

    },
    getDefaultPostFilter() {
      let filter = {};

      filter["search"] = null;
      filter["min_reviews"] = null;
      filter["time"] = {};
      filter["time"]["from"] = null;
      filter["time"]["till"] = null;
      filter["sentiment"] = null;
      filter["platforms"] = null;
      filter["woorden"] = null;
      filter["branches"] = null;

      return filter;
    },
  },
  mounted() {
    this.$parent.setCurrentPage(this);
  },
};
</script>
